import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  TextField,
  FormControl,
  Button,
  Box,
  Modal,
} from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';

const ADD_NEW_VALUE = '__add_new__';

const DropdownWithAdd = ({ label, options, value, onChange, disabled, onAddOptions,modalLabel }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [newOption, setNewOption] = useState('');

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === ADD_NEW_VALUE) {
      setOpenDialog(true);
    } else {
      onChange(selectedValue);
    }
  };

  const handleAdd = () => {
    const trimmed = newOption.trim();
    if (trimmed && !options.some(opt => opt.value === trimmed)) {
      // const newOpt = { label: trimmed, value: trimmed };
      // onChange(newOpt.value);
      onAddOptions(trimmed);
    }
    setNewOption('');
    setOpenDialog(false);
  };

  return (
    <>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          disabled={disabled}
          inputProps={{ 'aria-label': 'Without label' }}
          renderValue={(selected) => {
            const selectedOption = options.find(opt => opt.value === selected);
            return selectedOption ? selectedOption.label : <em>{label}</em>;
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                overflowY: 'auto',
                position: 'relative',
                width: "100px",
                padding: "0px"
              },
            },
          }}
        >
          <MenuItem value={0}>
            <em>{label}</em>
          </MenuItem>

          {options.map((opt, idx) => (
            <MenuItem key={idx} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}

          <MenuItem
            value={ADD_NEW_VALUE}
            disabled
            style={{
              position: 'sticky',
              bottom: 0,
              background: '#fff',
              borderTop: '1px solid #ccc',
              zIndex: 1000,
              opacity: 1,
              pointerEvents: 'auto',
            }}
          >
            <div
              onClick={(e) => {
                e.stopPropagation();
                setOpenDialog(true);
              }}
              style={{
                width: '100%',
                cursor: 'pointer',
                padding: '8px 0px',
              }}
            >
              <AddCircleOutline /> Add New
            </div>
          </MenuItem>
        </Select>
      </FormControl>

      {/* Dialog */}
      <Modal
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        className="displayblock"
      >
        <Box className="modalpopup" sx={{ width: "350px" }}>
          <Box className="row modalpopupinner">
            <h5 className='headercontent'>Add New {modalLabel}</h5>

            <TextField
              fullWidth
              autoFocus
              label={modalLabel}
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
            />

            <Button
              fullWidth
              variant="contained"
              color="primary"
              className="Loginbutton mar-48"
              onClick={handleAdd}
            >
              Add
            </Button>

            <Button
              onClick={() => setOpenDialog(false)}
              fullWidth
              variant="contained"
              color="secondary"
              className="closebutton"
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DropdownWithAdd;
